import { useTranslations } from "next-intl";

export default function DonationNotice() {
  const t = useTranslations("default");
  return (
    <div className="ps-4 pb-4 pe-4 text-xs text-gray-500">
      {t("donation_notice")}
    </div>
  );
}
